module.exports = __webpack_public_path__ + "static/media/404.ad4b5c8a.svg";